export enum DATE_TIME_TYPE {
  DATE_TIME = 'datetime-local',
  DATE = 'date',
  TIME = 'time'
}

export enum DateTimeFormat {
  DATE_TIME = 'DD MMM, YYYY | hh:mm A',
  DATE_ONLY = 'DD MMM, YYYY',
  TIME_ONLY = 'hh:mm A'
}
